const GENERAL_DYNAMICS_ELIGIBILITY_DETAILS_SEARCH = {
  'affiliation_id'          : 270,
  'name'                    : 'gd',
  'description'             : 'General Dynamics',
  'charge_amount'           : 38.0,
  'type'                    : '270/271',
  'preregistration_date'    : '2016-04-01',
  'activation_date'         : '2014-08-01',
  'primary_members_only'    : false,
  'allow_add_family_members': true,
  'is_child_affiliation'    : false,
  'use_monikers'            : false,
  'sub_plan_affiliations'   : [],
  'org'                     : {
    'id'            : 3921,
    'org'           : 'gd',
    'affiliation_id': 270,
    'created_at'    : '2016-01-28T17:10:48.000-05:00',
    'updated_at'    : '2016-01-28T17:10:48.000-05:00',
    'monikers'      : [],
  },
  'tooltip_image'           : null,
  'insurance_label'         : null,
  'business_units'          : [
    {
      'id'             : 58,
      'name'           : 'C4S',
      'insurance_plans': [
        {
          'id'                : 363,
          'name'              : 'BCBS PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 364,
          'name'              : 'BCBS PHA NSE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 365,
          'name'              : 'BCBS PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 366,
          'name'              : 'BCBS PPO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 367,
          'name'              : 'CIGNA Care Network',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 368,
          'name'              : 'CIGNA OAP CareLink',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 369,
          'name'              : 'CIGNA PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 370,
          'name'              : 'CIGNA PHA NSE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 371,
          'name'              : 'CIGNA PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 372,
          'name'              : 'UHC Choice Plus',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 373,
          'name'              : 'UHC PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 374,
          'name'              : 'UHC PHA NSE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 375,
          'name'              : 'UHC PHA S',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 59,
      'name'           : 'CHQ',
      'insurance_plans': [
        {
          'id'                : 376,
          'name'              : 'CIGNA PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 377,
          'name'              : 'CIGNA PHA NSE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 378,
          'name'              : 'CIGNA PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 379,
          'name'              : 'UHC PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 380,
          'name'              : 'BCBS PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 381,
          'name'              : 'BCBS PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 382,
          'name'              : 'BCBS PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 383,
          'name'              : 'UHC PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 384,
          'name'              : 'UHC PHA S',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 60,
      'name'           : 'Electric Boat',
      'insurance_plans': [
        {
          'id'                : 385,
          'name'              : 'High Deductible Acct Based-UHC MDA',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 386,
          'name'              : 'Protection Plus UHC (MDA)',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 387,
          'name'              : 'Protection Plus UHC (MTC)',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 388,
          'name'              : 'UHC Indemnity',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 389,
          'name'              : 'High Deductible Acct Based UHC Enhanced',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 390,
          'name'              : 'High Deductible Acct Based- UHC Hourly Enhanced',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 391,
          'name'              : 'High Deductible Acct Based-UHC MTC Enhanced',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 392,
          'name'              : 'Protection Plus UHC MTC Retiree',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 393,
          'name'              : 'High Deductible Acct Based-UHC MTC Standard',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 394,
          'name'              : 'High Deductible Acct Based-UHC Standard',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 395,
          'name'              : 'ABHP UHC Carpenters Enhanced',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 396,
          'name'              : 'ABHP UHC Carpenters Standard',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 61,
      'name'           : 'Gulfstream Aerospace Corp',
      'insurance_plans': [
        {
          'id'                : 397,
          'name'              : 'BCBS PHA GAC',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 398,
          'name'              : 'BCBS PPO GAC',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 399,
          'name'              : 'CS Savannah PHAP',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 400,
          'name'              : 'CS Savannah PPO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 401,
          'name'              : 'UHC Choice Plus GAC',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 402,
          'name'              : 'UHC PHA GAC',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 403,
          'name'              : 'BCBS PHA GAC Retiree',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 404,
          'name'              : 'BCBS PPO GAC Retiree',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 405,
          'name'              : 'CS Savannah PHAP Retiree',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 406,
          'name'              : 'CS Savannah PPO Retiree',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 62,
      'name'           : 'GDIT',
      'insurance_plans': [
        {
          'id'                : 407,
          'name'              : 'BCBS PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 408,
          'name'              : 'BCBS PHA NSE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 409,
          'name'              : 'BCBS PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 410,
          'name'              : 'CIGNA PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 411,
          'name'              : 'CIGNA PHA NSE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 412,
          'name'              : 'CIGNA PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 413,
          'name'              : 'UHC PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 414,
          'name'              : 'UHC PHA NSE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 415,
          'name'              : 'UHC PHA S',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 63,
      'name'           : 'Jet Aviation',
      'insurance_plans': [
        {
          'id'                : 416,
          'name'              : 'CIGNA PHA JAUS',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 417,
          'name'              : 'CIGNA Premium Plan JAUS',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 418,
          'name'              : 'CIGNA OAP-Carelink Jet Pro PEO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 419,
          'name'              : 'CIGNA Personal Health Acct S JA',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 64,
      'name'           : 'NASSCO',
      'insurance_plans': [
        {
          'id'                : 420,
          'name'              : 'BCBS PPO NASSCO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 421,
          'name'              : 'BCBS PHA NASSCO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 422,
          'name'              : 'BCBS PHA NASSCO NE',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 423,
          'name'              : 'BCBS Personal Health Acct NASSCO (Norfolk Union)',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 65,
      'name'           : 'SRI',
      'insurance_plans': [
        {
          'id'                : 424,
          'name'              : 'BCBS PHA GAC',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 425,
          'name'              : 'BCBS PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 426,
          'name'              : 'BCBS PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 427,
          'name'              : 'BCBS PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 428,
          'name'              : 'CIGNA PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 429,
          'name'              : 'CIGNA PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 430,
          'name'              : 'CIGNA PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 431,
          'name'              : 'UHC PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 432,
          'name'              : 'UHC PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 433,
          'name'              : 'UHC PHA S',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 66,
      'name'           : 'GD-OTS',
      'insurance_plans': [
        {
          'id'                : 434,
          'name'              : 'BCBS PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 435,
          'name'              : 'BCBS PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 436,
          'name'              : 'BCBS PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 437,
          'name'              : 'BCBS PHA S ATP Marion',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 438,
          'name'              : 'BCBS PPO ATP Marion',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 439,
          'name'              : 'BCBS PPO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 440,
          'name'              : 'CIGNA PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 441,
          'name'              : 'CIGNA PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 442,
          'name'              : 'CIGNA PHA E Saco',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 443,
          'name'              : 'CIGNA PHA non-seeded E Saco',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 444,
          'name'              : 'CIGNA PHA E BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 445,
          'name'              : 'CIGNA PHA non-seeded E BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 446,
          'name'              : 'CIGNA PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 447,
          'name'              : 'CIGNA PHA S Saco',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 448,
          'name'              : 'CIGNA PHA S BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 449,
          'name'              : 'CIGNA OAP-CareLink',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 450,
          'name'              : 'CIGNA OAP-CareLink BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 451,
          'name'              : 'CIGNA Care Network',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 452,
          'name'              : 'CIGNA Care Network BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 453,
          'name'              : 'UHC PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 454,
          'name'              : 'UHC PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 455,
          'name'              : 'UHC PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 456,
          'name'              : 'UHC PHA S ATP Lincoln',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 457,
          'name'              : 'UHC Choice Plus',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 458,
          'name'              : 'UHC Choice Plus PPO ATPLinc',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 459,
          'name'              : 'UHC Core Plan Springboro',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 67,
      'name'           : 'AMSEA',
      'insurance_plans': [
        {
          'id'                : 460,
          'name'              : 'BCBS PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 461,
          'name'              : 'BCBS PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 462,
          'name'              : 'BCBS PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 463,
          'name'              : 'CIGNA PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 464,
          'name'              : 'CIGNA PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 465,
          'name'              : 'CIGNA PHA S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 466,
          'name'              : 'UHC PHA E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 467,
          'name'              : 'UHC PHA non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 468,
          'name'              : 'UHC PHA S',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 68,
      'name'           : 'LS',
      'insurance_plans': [
        {
          'id'                : 469,
          'name'              : 'BCBS M PPO A',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 470,
          'name'              : 'BCBS M PPO Rep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 471,
          'name'              : 'BCBS M PPO Rep Retiree',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 472,
          'name'              : 'BCBS M Personal Health Acct Enhanced',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 473,
          'name'              : 'BCBS M Personal Health Acct Union',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 474,
          'name'              : 'BCBS M Retiree Union',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 475,
          'name'              : 'BCBS M Retiree Choice',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 476,
          'name'              : 'BCBS M PHA Retiree Enhanced',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 477,
          'name'              : 'BCBS M PHA Retiree Standard',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 478,
          'name': 'BCBS M PHA - UAW Seeded',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 479,
          'name': 'BCBS M PHA 90_10 Unmatched',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 480,
          'name': 'BCBS M PHA 80_20 Unmatched',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 481,
          'name': 'BCBS M PHA 70_30 Unmatched',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 482,
          'name': 'BCBS M Retiree PHA - UAW Seeded',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 483,
          'name': 'BCBS M Retiree PHA - UAW Unseeded',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 484,
          'name': 'BCBS M PHA - UAW Unseeded',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 69,
      'name': 'OTS',
      'insurance_plans': [
        {
          'id'                : 485,
          'name': 'BCBS Personal Health Acct E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 486,
          'name': 'BCBS Personal Health Acct S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 487,
          'name': 'BCBS Personal Health Acct non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 488,
          'name': 'Cigna Personal Health Acct E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 489,
          'name': 'Cigna Personal Health Acct S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 490,
          'name': 'Cigna Personal Health Acct non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 491,
          'name': 'UHC Personal Health Acct E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 492,
          'name': 'UHC Personal Health Acct S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 493,
          'name': 'UHC Personal Health Acct non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 494,
          'name': 'Cigna Care Network BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 495,
          'name': 'Cigna OAP-CareLink BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 496,
          'name': 'Cigna Personal Health Acct E BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 497,
          'name': 'Cigna Personal Health Acct S BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 498,
          'name': 'Cigna Personal Health Acct non-seeded E BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 499,
          'name': 'Cigna Care Network',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 500,
          'name': 'BCBS PPO ATP Marion',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 501,
          'name': 'BCBS Personal Health Acct S ATP Marion',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 502,
          'name': 'Cigna Personal Health Acct S Saco',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 503,
          'name': 'Cigna Personal Health Acct E Saco',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 504,
          'name': 'BCBS Alabama PHA Enhanced Seeded',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 505,
          'name': 'Cigna PHA Enhanced Seeded',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 506,
          'name': 'UHC PHA Enhanced Seeded',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 70,
      'name': 'MS',
      'insurance_plans': [
        {
          'id'                : 507,
          'name': 'BCBS PPO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 508,
          'name': 'Cigna OAP-CareLink',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 509,
          'name': 'UHC Choice Plus',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 510,
          'name': 'Cigna Care Network',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 71,
      'name': 'MIS',
      'insurance_plans': [
        {
          'id'                : 511,
          'name': 'BCBS A (GDGIT)',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 512,
          'name': 'BCBS Personal Health Acct E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 513,
          'name': 'BCBS Personal Health Acct S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 514,
          'name': 'BCBS Personal Health Acct non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 515,
          'name': 'Cigna Personal Health Acct E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 516,
          'name': 'Cigna Personal Health Acct S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 517,
          'name': 'Cigna Personal Health Acct non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 518,
          'name': 'UHC Personal Health Acct E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 519,
          'name': 'UHC Personal Health Acct S',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 520,
          'name': 'UHC Personal Health Acct non-seeded E',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 521,
          'name': 'BCBS PPO',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 522,
          'name': 'BCBS Personal Health Acct C',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 523,
          'name': 'UHC Personal Health Acct C',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 524,
          'name': 'Cigna Personal Health Acct C',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 525,
          'name': 'Cigna OAP-CareLink',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 526,
          'name': 'UHC Choice Plus',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 527,
          'name': 'Cigna Care Network BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 528,
          'name': 'Cigna OAP-CareLink BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 529,
          'name': 'Cigna Personal Health Acct E BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 530,
          'name': 'Cigna Personal Health Acct S BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 531,
          'name': 'Cigna Personal Health Acct non-seeded E BPRep',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 532,
          'name': 'Cigna Care Network',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 72,
      'name': 'Legacy OTS',
      'insurance_plans': [
        {
          'id'                : 533,
          'name': 'BCBS A PPO 70',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 534,
          'name': 'BCBS Alabama PHA Matched OTS',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 535,
          'name': 'BCBS Alabama PHA S OTS',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 536,
          'name': 'BCBS Alabama PHA Seeded OTS',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 537,
          'name': 'BCBS Alabama PHA Unseeded OTS',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 538,
          'name': 'BCBS Hourly PPO (Marion Rep)',
          'insurance_payer_id': 97,
        }],
    },
    {
      'id'             : 73,
      'name': 'Bath Iron Works',
      'insurance_plans': [
        {
          'id'                : 539,
          'name': 'Cigna PHAP BIW (LS6 \u0026 IGA)',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 540,
          'name': 'Cigna PHAP Standard BIW',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 541,
          'name': 'Cigna PCP Select (BMDA and LS7)',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 542,
          'name': 'Cigna PCP Select (LS6 and IGA)',
          'insurance_payer_id': 97,
        },
        {
          'id'                : 543,
          'name': 'Cigna PHAP BIW (BMDA \u0026 LS7)',
          'insurance_payer_id': 97,
        }],
    }],
}

module.exports = GENERAL_DYNAMICS_ELIGIBILITY_DETAILS_SEARCH


// WEBPACK FOOTER //
// ./registration-react/__mocks__/general_dynamics_eligibility_details.js